import {
  ACTIVATING_SIX_SENSE_REQUEST, ACTIVATING_SIX_SENSE_SUCCEDDED, ACTIVATING_SIX_SENSE_FAILED,
  UPDATING_SIX_SENSE_REQUEST, UPDATING_SIX_SENSE_SUCCEDDED, UPDATING_SIX_SENSE_FAILED
} from '../actionTypes.jsx';
import { activatingIntegrationSuccedded, deactivatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const SIX_SENSE_BASE_URL = `${apiUrl}/api/2.0/integrations/six-sense`;

export function activateAccount(configuration) {
  return function (dispatch) {
    dispatch(activatingAccount());

    return axios({
      method: 'POST',
      url: SIX_SENSE_BASE_URL,
      data: configuration
    })
      .then((response) => {
        dispatch(activatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
        return response.data;
      })
      .catch(error =>
        dispatch(activatingAccountFailed(error.errors))
      )
  }
}

function activatingAccount() {
  return {
    type: ACTIVATING_SIX_SENSE_REQUEST,
    payload: {}
  }
}

function activatingAccountSuccedded(json) {
  return {
    type: ACTIVATING_SIX_SENSE_SUCCEDDED,
    payload: json
  }
}

function activatingAccountFailed(error) {
  return {
    type: ACTIVATING_SIX_SENSE_FAILED,
    payload: error
  }
}

export function updateSixSenseConfiguration(configuration) {
  return function (dispatch) {
    dispatch(updatingSixSenseConfiguration());

    return axios({
      method: 'PUT',
      url: SIX_SENSE_BASE_URL,
      data: configuration
    })
      .then((response) => {
        dispatch(updatingSixSenseConfigurationSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error =>
        dispatch(updatingSixSenseConfigurationFailed(error.errors))
      )
  }
}

function updatingSixSenseConfiguration() {
  return {
    type: UPDATING_SIX_SENSE_REQUEST,
    payload: {}
  }
}

function updatingSixSenseConfigurationSuccedded(json) {
  return {
    type: UPDATING_SIX_SENSE_SUCCEDDED,
    payload: json
  }
}

function updatingSixSenseConfigurationFailed(error) {
  return {
    type: UPDATING_SIX_SENSE_FAILED,
    payload: error
  }
}
